<template>
  <div id="login">

<div class="flex h-full min-h-screen bg-gray-900 w-full bg-cover bg-no-repeat" 
style="background-image:url('/static/images/download-bg.png'); background-repeat: no-repeat;">
<div class="bg-opacity-50 w-full h-full min-h-screen   flex items-center justify-center bg-black">


  <div class="holder rounded-2xl  bg-white  overflow-y-auto  px-16 py-10 my-10 shadow-lg backdrop-blur-md max-sm:px-8">
    <div class="text-white">
      <div class="flex flex-col items-center">
          <img
            src="/static/images/passport-logo-blue.png"
            width="180px"
            height="180px"
          />
      </div>


      <div>

        <div class="w-full mx-auto h-100" v-if="loginInView">
          <h1
            class="
              text-xl
              md:text-3xl
              font-bold
              leading-tight
              mt-6
              md:mt-10
              mb-2
              mx-auto
              text-slate-700
              text-center
            "
          >
            Welcome back
          </h1>
          <p class="text-slate-700 text-center">Please enter your details to login.</p>

          <form class="mt-6" v-on:submit.prevent="login">
            <div>
              <label class="block font-semibold text-gray-700">Username</label>
              <input
                type="text"
                placeholder="Enter your username"
                v-model="username"
                class="
                  rounded
                  mt-2
                  focus:border-blue-500 focus:bg-white focus:outline-none
                "
                autofocus
                autocomplete
                required
              />

              <div class="validation_error on_email" id="errorEmail">
                MUST ENTER A VALID EMAIL
              </div>
            </div>

            <div class="mt-4">
              <label class="block font-semibold text-gray-700">Password</label>
              <input
                type="password"
                v-model="password"
                placeholder="Enter Password"
                minlength="4"
                class="
                  rounded
                  mt-2
                  focus:border-blue-500 focus:bg-white focus:outline-none
                "
                required
              />
              <div class="validation_error on_passcode" id="errorPasscode">
                MUST ENTER A VALID PASSCODE
              </div>
            </div>

            <div class="text-right mt-2">
              <a
                @click="loginInView = false"
                class="
                  text-sm
                  font-semibold
                  text-blue-500
                  hover:text-blue-700
                  focus:text-blue-700
                  cursor-pointer
                  my-2
                "
                >Forgot Password?</a
              >
            </div>

            <button
              type="submit"
              id="login-button"
              class="
                w-full
                block
                bg-action-blue
                bg-opacity-75
                hover:bg-opacity-50
                focus:bg-action-blue focus:bg-opacity-50
                text-white
                font-semibold
                rounded
                px-4
                py-3
                mt-6
                bg-gradient-to-tl bg-action-blue hover:shadow-soft-2xl 
              "
            >
              Sign In
            </button>
          </form>

          <hr class="my-6 border-gray-300 w-full" />
          <div
            class="alert bg-red-300 rounded p-4 text-red-700"
            v-if="errorVisible"
          >
            <p v-html="error"></p>
          </div>
          <div
            style="width: 100%; text-align: center"
            class="spin-holder mt-0"
            v-if="loading"
          >
            <i class="spinner fa fa-spinner fa-spin"></i>
            <p>Loading</p>
          </div>

          <button
            v-if="1 == 3"
            style="display: none"
            class="
              w-full
              block
              bg-white
              hover:bg-gray-100
              focus:bg-gray-100
              text-gray-900
              font-semibold
              rounded
              px-4
              py-3
              border border-gray-300
            "
          >
            <div class="flex items-center justify-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                class="w-6 h-6"
                viewBox="0 0 48 48"
              >
                <defs>
                  <path
                    id="a"
                    d="M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z"
                  />
                </defs>
                <clipPath id="b">
                  <use xlink:href="#a" overflow="visible" />
                </clipPath>
                <path clip-path="url(#b)" fill="#FBBC05" d="M0 37V11l17 13z" />
                <path
                  clip-path="url(#b)"
                  fill="#EA4335"
                  d="M0 11l17 13 7-6.1L48 14V0H0z"
                />
                <path
                  clip-path="url(#b)"
                  fill="#34A853"
                  d="M0 37l30-23 7.9 1L48 0v48H0z"
                />
                <path
                  clip-path="url(#b)"
                  fill="#4285F4"
                  d="M48 48L17 24l-4-3 35-10z"
                />
              </svg>
              <span class="ml-4"> Log in with Google</span>
            </div>
          </button>

          <p class="mt-8 text-center mx-auto text-slate-700 ">
            Don't have an account?
            <a
              href="https://primarypepassport.co.uk"
              target="_blank"
              class="text-blue-500 hover:text-blue-700 font-bold"
              >Sign up</a
            >
          </p>

          <div
          class="
 
            pt-6
            text-gray-600 text-xs
            font-semibold
            mb-0
            bottom-0
           mx-auto
           text-center
          "
        >&copy; PE Passport v.{{ this.$version }}
        </div>
        </div>

        <div v-else>
          <forgottenpass @back="loginInView = true" />
        </div>

        </div>

   
    </div>
         
  </div>
  </div>
</div>



  </div>
</template>

  <script>
const forgottenpass = () => import("@/components/ForgotPassword.vue");

import { mapGetters } from "vuex";

export default {
  name: "login",
  computed: {},
  data() {
    return {
      isMobileView: false,
      loginInView: true,
      username: "",
      password: "",
      errorVisible: false,
      error: "",
      loading: false,
      networkMsg:
        "Could not connect to the server. <br/> Please contact our support team for further assistance.",
    };
  },
  computed: {
    ...mapGetters({ 
      currentUser: "currentUser",
      subjects: "subjects",

     }),
    canlogin() {
      return this.username.trim().length > 2 && this.password.trim().length > 3;
    },
  },
  created() {
    this.isMobile();
    this.checkCurrentLogin();
  },
  updated() {
    this.checkCurrentLogin();
  },
  methods: {
    isMobile() {
      if (screen.width <= 780) {
        this.isMobileView = true;
      } else {
        this.isMobileView = false;
      }
    },
    checkCurrentLogin() {
      if (this.currentUser) {
        //this.$router.replace(this.$route.query.redirect || '/mainx')
      }
    },
    login() {
      this.loading = true;
      this.errorVisible = false;

      var username = this.username.trim();
      var password = this.password.trim();

      this.$store
        .dispatch("login", { username, password })
        .then(() => this.loginSuccess())
        .catch((err) => this.loginFailure(err));
    },
    loginSuccess() {
      this.$store
        .dispatch("configure")
        .catch((err) => console.log("SETTING EOROR", err));
      this.loading = false;

      if (this.subjects.isBased) {
        this.$router.push("/subjects");
      } else {
        this.$router.push("/");
      }
    },
    loginFailure(err) {
      console.log(err);
      this.loading = false;
      this.errorVisible = true;
      this.error = err === "network_error" ? this.networkMsg : "Login Failed!";
      this.$store.dispatch("logout");
    },
    logoName() {
      switch (this.$domain) {
        case "secondarypepassport":
          return "secondary-passport-logo";
          break;
        case "gcsepepassport":
          return "gcse-passport-logo";
          break;
        default:
          return ["my", "app", "localhost:8080"].includes(this.$hostname)
            ? "passport-logo"
            : this.$hostname;
      }
    },
    setButtonStyle() {
      switch (this.$domain) {
        case "secondarypepassport":
          return "bg-secondary-blue";
          break;
        case "gcsepepassport":
          return "bg-gcse-teal";
          break;
        default:
          return "bg-pink-red";
      }
    },
  },
  components: {
    forgottenpass,
  },
};
</script>

<style scoped>
/* validation messages */
.validation_error {
  display: none;
  width: 100%;
  height: 40px;
  text-align: center;
  background-color: #ee6055;
  color: white;
  font-size: 130%;
  float: none;
  clear: both;
  margin-bottom: 12px;
}

.success {
  display: none;
  width: 100%;
  height: 201px;
  text-align: center;
  background-color: #60d394;
  color: white;
  font-size: 130%;
  float: none;
  clear: both;
  margin-bottom: 12px;
  padding: 17px;
}

.success h2 {
  color: #fff;
}

.success p {
  text-transform: none;
  font-size: 13px;
  line-height: normal !important;
}

.login-form-btn:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}

.holder {
  @apply h-4/5  w-1/3;
}

	@media screen and (min-width: 1680px) {
    .holder {
       @apply h-2/3  w-1/3;
    }
  }

</style>
